import React from "react";
import { NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import image1 from "../../images/galleries/1.jpg";
import image2 from "../../images/galleries/2.jpg";
import image3 from "../../images/galleries/3.jpg";
import image4 from "../../images/galleries/4.jpg";
import image5 from "../../images/galleries/5.jpg";
import image6 from "../../images/galleries/6.jpg";

const filters = [
  { label: "Bathroom", filter: ".col-one" },
  { label: "Decoration", filter: ".col-two" },
  { label: "Kitchen", filter: ".col-three" },
  { label: "Living room", filter: ".col-four" },
];

const projects = [
  {
    image:
      image1,
    title: "Chair Furniture",
    address: "Muscat, Sultanate of Oman",
    filter: "col-one",
  },
  {
    image:
      image2,
    title: "Chair Furniture",
    address: "Muscat, Sultanate of Oman",
    filter: "col-two",
  },
  {
    image: image3,
    title: "Chair Furniture",
    address: "Muscat, Sultanate of Oman",
    filter: "col-three",
  },
  {
    image:
      image4,
    title: "Chair Furniture",
    address: "Muscat, Sultanate of Oman",
    filter: "col-four",
  },
  {
    image:
      image5,
    title: "Chair Furniture",
    address: "Muscat, Sultanate of Oman",
    filter: "col-three",
  },
  {
    image: image6,
    title: "Chair Furniture",
    address: "Muscat, Sultanate of Oman",
    filter: "col-two",
  },
];

var bgimg1 = require("./../../images/background/cross-line2.png");

class Projects1 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/custom.js");
  }
  render() {
    const options = {
      loop: true,
      autoplay: false,
      margin: 0,
      nav: true,
      dots: false,
      animateOut: "slideOutDown",
      animateIn: "flipInX",
      smartSpeed:450,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        540: {
          items: 2,
        },
        768: {
          items: 3,
        },
        991: {
          items: 3,
        },
        1136: {
          items: 3,
        },
        1366: {
          items: 3,
        },
      },
    };
    return (
      <>
        <div className="section-full mobile-page-padding  p-t20 p-b20 bg-white">
          <div className="section-content">
            <div className="container">
              {/* TITLE START */}
              <div data-aos-duration="800"  data-aos="fade-up" className="section-head">
                <div className="sx-separator-outer separator-center">
                  <div
                    className="sx-separator bg-white bg-moving bg-repeat-x"
                    // style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                  >
                    <h3 className="sep-line-one">Galerie Photos</h3>
                  </div>
                </div>
              </div>
              {/* TITLE END */}
            </div>
            <div className=" filter-carousal-1-outer relative z-index1">
              {/* <div className="container">
                                <div className="text-center clearfix filter-pos-right shadow m-b30">
                                    <ul className="btn-filter-wrap">
                                        <li className="btn-filter btn-active" data-filter="*">All</li>
                                        {filters.map((item, index) => (
                                            <li key={index} className="btn-filter" data-filter={item.filter}>{item.label}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div> */}
              {/* TITLE END */}
              <div className="filter-carousal-1  container-fluid p-b30">
                {/* IMAGE CAROUSEL START */}
                <div className="section-content ">
                  <OwlCarousel
                    className="owl-carousel owl-carousel-filter  owl-btn-bottom-center mfp-gallery navigation-with-name"
                    {...options}
                  >
                    {projects.map((item, index) => (
                      <div
                        key={index}
                        className={`${item.filter} item fadingcol overflow-hide`}
                        data-aos-duration="800"  data-aos="zoom-in-up"
                      >
                        <div className="sx-box   image-hover-block">
                          <div className="sx-thum-bx">
                            <img src={item.image} alt="" />
                          </div>

                          <a className="mfp-link" href={item.image}>
                            <i className="fa fa-arrows-alt" />
                          </a>
                        </div>
                      </div>
                    ))}
                  </OwlCarousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Projects1;
